module.exports = __webpack_public_path__ + "static/media/shirt.00a37696.svg";